import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const ProfileTemperatureForm = ({
  visible,
  onClose,
  node,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Frio (10°-)", value: 1 },
    { label: "Ameno (10° - 20°)", value: 2 },
    { label: "Calor (20° - 30°)", value: 4 },
    { label: "Muito calor (30°+)", value: 8 },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.ProfileTemperature}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        timerange={false}
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
